const rootActionPath = 'core/bonusRollingModal';

export const BONUS_ROLLING_MODAL_VIEW = `${rootActionPath}/VIEW`;
export const BONUS_ROLLING_MODAL_ON_OVERLAY_CLICK_CLOSE = `${rootActionPath}/ON_OVERLAY_CLICK_CLOSE`;
